/* Build in libraries */

import { useState } from 'react';
/* Services */
import { CRAllApplications } from '@/features/ApplicationForm/FormConfig/CR/CRDashboard/CRAllApplications';
/* Components */
import { CRApprovedDashboard } from './CRApprovedDashboard';

interface IApplicationDashboardComponentProps {
  data: any;
  defaultView?: 'ALL' | 'APPROVED';
  hideSwitch?: boolean;
}

export const CRDashboard = ({ data, defaultView = 'ALL', hideSwitch }: IApplicationDashboardComponentProps) => {
  const [viewStatus, setViewStatus] = useState<string>(defaultView);

  return (
    <div className='max-w-screen-3xl mx-auto'>
      {!hideSwitch && (
        <div className='font-semibold text-bold py-4 rounded-md space-x-2'>
          <span
            className={`${
              viewStatus === 'ALL' ? 'bg-primaryColor-normal' : 'bg-neutralColor-light hover:bg-primaryColor-normal'
            } text-white px-4 py-2 cursor-pointer`}
            onClick={() => setViewStatus('ALL')}
          >
            All Submissions
          </span>
          <span
            className={`${
              viewStatus === 'APPROVED' ? 'bg-primaryColor-normal' : 'bg-neutralColor-light hover:bg-primaryColor-normal'
            } text-white px-4 py-2 cursor-pointer`}
            onClick={() => setViewStatus('APPROVED')}
          >
            Approved Submissions
          </span>
        </div>
      )}

      {viewStatus === 'ALL' && <CRAllApplications data={data} />}
      {viewStatus === 'APPROVED' && <CRApprovedDashboard data={data} />}
    </div>
  );
};
